export default "__VITE_ASSET__B_Tw6atN__"